import React, { Suspense, useRef, useState } from "react";
import { GlobalCanvas, SmoothScrollbar } from "@14islands/r3f-scroll-rig";
import { Environment, Loader } from "@react-three/drei";
import { BodyCopy, Headline, Subtitle } from "./Text";
import { Image } from "./Image";
import { Image1 } from "./Image1";
import { Image2 } from "./Image2";
import { ImageCube } from "./ImageCube";
import { WebGLBackground } from "./WebGLBackground";
import { Lens } from "./Lens";
import CodropsFrame from "./CodropsFrame";
import {default as BackToTop} from "./BackToTop";
import "@14islands/r3f-scroll-rig/css";

export default function App() {
  const eventSource = useRef();
  const [enabled, setEnabled] = useState(true);

  return (
    <div ref={eventSource}>
      <CodropsFrame />
      <GlobalCanvas
        debug={false}
        scaleMultiplier={0.01}
        eventSource={eventSource}
        eventPrefix="client"
        flat
        camera={{ fov: 14 }}
        style={{ pointerEvents: "none", zIndex: -1 }}
      >
        {(globalChildren) => (
          <Lens>
            <WebGLBackground />
            <Suspense fallback="">
              <Environment files="env/empty_warehouse_01_1k.hdr" />
              {globalChildren}
            </Suspense>
          </Lens>
        )}
      </GlobalCanvas>
      <SmoothScrollbar
        enabled={enabled}
        config={{ syncTouch: true }} // Lenis setting to force smooth scroll on touch devices
      />
      <article>
        {/* <EffectsToggle setEnabled={setEnabled} enabled={enabled} /> */}
        <header className="container">
          <div className="headerLayout">
            <h2>
              <Headline wobble>Akbarali Nabiev {enabled ? "" : ""}</Headline>
            </h2>

            <BodyCopy as="p" className="subline text-about">
              UI/UX Designer skilled in optimizing work processes to enhance user experiences and deliver products that are easy to use and enjoyable.
            </BodyCopy> 
          </div>
        </header>
        <section className="container">
          
          <Image2
            src="images/maxim-berg-1_U2RcHnSjc-unsplash.jpg"
            className="ImageLandscape"
          />
        </section>
        <section className="container">
          <h3>
            <Subtitle className="text-design-quote">
              "Design is where Science and Art break even"
            </Subtitle>
            <em>
              <Subtitle>¯Mieke Gerritzen</Subtitle>
            </em>
          </h3>
          <p className="text-about-body">
            <BodyCopy>
              As a multi-disciplinary designer, my expertise extends to curating
              visually captivating web experiences, emphasizing interactive joy,
              and seamlessly integrating organic motion into the design
              landscape.
            </BodyCopy>
          </p>
        </section>

        <h2 className="ParallaxContainer-mobile-text">
          <Subtitle className="">Selected works</Subtitle>
        </h2>

        <section className="ParallaxContainer">
          <Image
            src="images/Screen.png"
            className="aspect-9_13"
            parallaxSpeed={1.5}
          />
          <div className="ParallaxContent-Container">
            <Image
              src="images/mackbook.png"
              className="aspect-16_11"
              parallaxSpeed={0.9}
            />
            <div className="study-case-link">
              <Subtitle className="ParallaxContent-Title">
                Designing a User-Centric Dashboard for Efficient Taxi Service
                Management.
              </Subtitle>
              <a
                className="little-title"
                href="https://www.behance.net/gallery/187769613/Start-Taxi-Server-Dashboard-Study-Case"
                target="_blank"
              >
                <Subtitle className="little-title">Case Study</Subtitle>
              </a>
            </div>
          </div>
        </section>

        {/* Here I put mobile screens */}

        <h2 className="ParallaxContainer-mobile-text">
          <Subtitle className="">Visual Delights</Subtitle>
        </h2>

        <section className="ParallaxContainer-mobile">
          <Image1
            src="images/1.png"
            className="aspect-16_11"
            parallaxSpeed={1.2}
          />
          <Image1
            src="images/2.png"
            className="aspect-16_11"
            parallaxSpeed={1.5}
          />
          <Image1
            src="images/3.png"
            className="aspect-16_11"
            parallaxSpeed={2.0}
          />
        </section>

        <section className="ParallaxContainer-mobile">
          <Image1
            src="images/4.png"
            className="aspect-16_11"
            parallaxSpeed={1.6}
          />
          <Image1
            src="images/5.png"
            className="aspect-16_11"
            parallaxSpeed={1.4}
          />
          <Image1
            src="images/6.png"
            className="aspect-16_11"
            parallaxSpeed={1.1}
          />
        </section>

        <section className="ParallaxContainer-mobile">
          <Image1
            src="images/7.png"
            className="aspect-16_11"
            parallaxSpeed={1.2}
          />
          <Image1
            src="images/8.png"
            className="aspect-16_11"
            parallaxSpeed={1.4}
          />
          <Image1
            src="images/9.png"
            className="aspect-16_11"
            parallaxSpeed={1.8}
          />
        </section>

        <section>
          {/* <ImageCube src="images/mobile.png" className="JellyPlaceholder" /> */}
        </section>

        <section className="container">
          <h3>
            <Subtitle>As a Designer I have a great responsibility.</Subtitle>
            <em>
              <Subtitle>
                I generate a multitude of potential solutions, exploring
                innovative approaches that push the boundaries of conventional
                thinking.
              </Subtitle>
            </em>
          </h3>

          <h2 className="ParallaxContainer-mobile-text">
            <Subtitle className="">Get in Touch</Subtitle>
          </h2>

          <section className="container">
            <h3>
              <Subtitle className="text-design">
                Clients are not supposed to have ideas, they have problems.
                Let's collaborate to transform these challenges into innovative
                design solutions.
              </Subtitle>
            </h3>
          </section>
          <section className="contact-section">
            <a
              className="contact-button"
              href="mailto:akbaralinabiev14@gmail.com"
            >
              <Subtitle className="contact-button-link">Get in Touch</Subtitle>
            </a>
          </section>
          <BackToTop />
        </section>
        <footer>
          <CodropsFrame />
        </footer>
      </article>

      <Loader
        containerStyles={{
          background: "transparent",
          top: "auto",
          bottom: 0,
          height: "5px",
        }}
        innerStyles={{ background: "white", width: "100vw", height: "5px" }}
        barStyles={{ background: "#6e6bcd", height: "100%" }}
      />
    </div>
  );
}
